export default __webpack_public_path__ + "static/media/img-ln-4-full-circle-economy.5098832e.png";